import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-tuodongtiaozheng",
  "use": "icon-tuodongtiaozheng-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-tuodongtiaozheng\"><path d=\"M1024 512L768 256v204.8H563.2V0H460.8v460.8H256V256L0 512l256 256V563.2h204.8V1024h102.4V563.2H768V768z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol